import React, { useState } from 'react';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import CaseCommentManager from 'containers/pages/comments/components/caseTable/CaseCommentManager';
import CaseCommentsTable from 'containers/pages/comments/components/caseTable/CaseCommentsTable';
import useCaseComments from 'containers/pages/cases/hooks/useCaseComments';

interface CaseCommentsProps {
	caseId: number;
	caseTitle: string;
	customerId: number;
	customerName: string;
	groupId: number;
	groupTitle: string;
	projectId: number;
	projectTitle: string;
	deliverableId: number;
	deliverableTitle: string;
}

const CaseComments: React.FC<CaseCommentsProps> = (props) => {
	const { state, handler } = useCaseComments(props);
	const [showDecimalFormat] = useState(true);

	if (state.loadingComments && state.comments.length === 0) {
		return (
			<Paper sx={{ p: 2 }}>
				<Skeleton variant="rounded" height={40} sx={{ mb: 2 }} />
				<Skeleton variant="rounded" height={200} />
			</Paper>
		);
	}

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
			<Paper sx={{ p: 2 }}>
				<CaseCommentManager
					setComments={handler.setComments}
					commentToCopy={state.commentToCopy}
					resetCommentToCopy={handler.resetCommentToCopy}
					defaultCase={state.defaultCaseContext}
				/>
			</Paper>

			{state.comments.length === 0 && !state.loadingComments ? (
				<Paper sx={{ p: 3 }}>
					<Typography
						variant="h6"
						align="center"
						fontWeight={300}
						color="text.secondary"
					>
						No comments found for this case
					</Typography>
				</Paper>
			) : (
				<CaseCommentsTable
					comments={state.comments}
					loadingComments={state.loadingComments}
					showDecimalFormat={showDecimalFormat}
					setComments={handler.setComments}
					onCopyCommentClick={handler.handleCopyComment}
					hideCaseInfo
					sortNewestFirst
				/>
			)}
		</Box>
	);
};

export default CaseComments;
